import gql from 'graphql-tag'
import { PersonPartsFragment } from '../People/mutations'

const CertificateFragment = gql`
  fragment CertificateParts on Certificate {
    id
    no
    expiration_date
    confirmation_date
    publisher
    dimensions
    dimension_s
    dimension_t
    dimension_d
    weld_detail_sorted
    material_groups {
      id
      name
      description
    }
    standard {
      id
      name
      slug
    }
    type_of_current_polarities {
      id
      name
      description
    }
    revalidation_methods {
      id
      name
      description
    }
    filler_materials {
      id
      name
      description
    }
    filler_material_groups {
      id
      name
      description
    }
    material_groups {
      id
      name
      description
    }
    product_types {
      id
      name
      description
    }
    type_of_welds {
      id
      name
      description
    }
    weld_details {
      id
      name
      description
    }
    welding_positions {
      id
      name
      description
    }
    welding_processes {
      id
      name
      description
    }
    type_of_weldings {
      id
      name
      description
    }
    metal_transfers {
      id
      name
      description
    }
    attachments {
      id
      data_file_name
      url
    }
    additional_info
    data
    approval {
      id
      no
      dimension_s
      dimension_t
      dimension_d
      filler_materials {
        id
        name
        description
      }
      filler_material_groups {
        id
        name
        description
      }
      material_groups {
        id
        name
        description
      }
      product_types {
        id
        name
        description
      }
      type_of_welds {
        id
        name
        description
      }
      weld_detail_sorted
      weld_details {
        id
        name
        description
      }
      welding_positions {
        id
        name
        description
      }
      welding_processes {
        id
        name
        description
      }
      type_of_weldings {
        id
        name
        description
      }
      metal_transfers {
        id
        name
        description
      }
     data
    }
  }
`

export const WeldersListFetchQuery = gql`
  query WeldersListFetchQuery($pageSize: Int = 5, $page: Int = 1, $filters: WelderFilterInput, $merge_by_cert_no: Boolean = false) {
    welders(page: $page, size: $pageSize, filters: $filters, merge_by_cert_no: $merge_by_cert_no) {
      list {
        id
        uuid
        first_name
        last_name
        certificates {
          ...CertificateParts
        }
      }
      metadata {
        total_count
        total_pages
        prev_page
        current_page
        next_page
      }
    }
  }
  ${CertificateFragment}
`
export const CertificateDictionariesQuery = gql`
  query WelderCertificateDictionariesQuery($standard_id: Int!, $welding_process_ids: [Int], $type_of_weld_ids: [Int],
   $product_type_ids: [Int], $skip_relations: Boolean) {
    welder_certificate_dictionaries(standard_id: $standard_id, welding_process_ids: $welding_process_ids, type_of_weld_ids: $type_of_weld_ids,
     product_type_ids: $product_type_ids, skip_relations: $skip_relations) {
      revalidation_methods {
        id
        name
        description
      }
      type_of_current_polarities {
        id
        name
        description
      } 
      filler_materials {
        id
        name
        description
      }
      filler_material_groups {
        id
        name
        description
      }
      product_types {
        id
        name
        description
      }
      type_of_welds {
        id
        name
        description
      }
      weld_details {
        id
        name
        description
      }
      welding_positions {
        id
        name
        description
      }
      welding_processes {
        id
        name
        description
      }
     material_groups {
        id
        name
        description
     }
     type_of_weldings {
        id
        name
        description
     }
     metal_transfers {
       id
       name
       description
     }
     qualification_data_types {
       id
       name
       description
     }
     vertical_progression
     backing
     yes_no
     type_of_run
     dimensions {
       id
       name
       description
     }
    }
  }
`

export const StandardsDimensionsWeldersQuery = gql`
  query StandardsDimensionsWeldersQuery($filters: PeopleFilterInput) {
    welder_certificate_standardizations {
      id
      name
      slug
    }
    dimensions {
      id
      name
      description
    }
    people(filters: $filters) {
      list {
        id 
        name
      }
    }
  }
`

export const createOrUpdateCertificatesMutation = gql`
  mutation createOrUpdateCertificates ($welder_certificate: WelderCertificateInput!) {
    createOrUpdateCertificates (welder_certificate: $welder_certificate) {
      certificate {
        ...CertificateParts
      }
      errors
      error_messages
    }
  }
  ${CertificateFragment}
`

export const destroyCertificateMutation = gql`
  mutation destroyCertificates($id: ID!) {
    destroyCertificates(id: $id) {
      response
    }
  }
`

export const createCertificateConfirmationMutation = gql`
  mutation createCertificateConfirmations($certificate_id: Int!, $confirmed_at: String!) {
    createCertificateConfirmations(certificate_id: $certificate_id, confirmed_at: $confirmed_at) {
      certificate {
        ...CertificateParts
      }
      errors
    }
  }
  ${CertificateFragment}
`

export const GET_CERTIFICATE = gql`
  query getCertificate($id: ID!) {
    certificate(id: $id) {
      ...CertificateParts
      person {
        ...PersonParts
        companies {
          id
          name
        }
        groups {
          id
          name
        }
      }
      designation
      last_confirmation
      next_confirmation
      certificate_valid
    }
    qualification_data_types {
      id
      name
    }
  }
${PersonPartsFragment}
${CertificateFragment}
`



// WEBPACK FOOTER //
// ./src/components/Welders/mutations.js